import type { FixedAssetRegisterTypes } from "@/redux/fixedAsset/fixedAssetRegisterTypes";

export const initialState: FixedAssetRegisterTypes = {
  fetching: false,
  fixedAssetHistorFetching: false,
  success: null,
  error: null,
  statusCode: null,
  finacAssetId: null,
  finacAssetIdFetching: false,
  message: null,
  finacAssetListing: [],
  totalCount: 0,
  singleFixedAsset: {},
  fixedAssetHistoryData: [],
  fixedAssetHistorySuccess: null,
  bulkUploadData: {},
  auditSessionListing: [],
  fixedAssetUsersHistoryData: [],
  auditSessionTotalCount: 0,
  assetHistoryFetching: false,
};
